import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { EMPTY } from 'rxjs';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap,catchError } from 'rxjs/operators';
import { DataApi } from 'src/app/Model/dataApi';
import { DataApiService } from 'src/app/services/data-api.service';
import { SeguridadService } from 'src/app/services/seguridad/seguridad.service';
import { ToastrServiceLocal } from 'src/app/services/toast/toastr.service';
import { MensajesHttpService } from 'src/app/utils/mensajesHttp/mensajes-http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EncuestasService {

  constructor(public router: Router, public _dataApi: SeguridadService, public _toast: ToastrServiceLocal, 
    public _mensajesHttp: MensajesHttpService) { }
    
  validarUsuario(params: any, callback:any) {
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    let url = `encuestas/api/encuestas/${environment.processEnv}/v1/security/validar-ingreso`;
    const request$ = this._dataApi.PostDataApiEncuestas(url,params).pipe(
      tap((result:any) => {
        this._toast.clearToasts();
        if (!result.hasError) {
          localStorage.setItem("token_go504", result['token-auth']);
          callback(result);
        } else {
          result.errors.forEach(element => {

            this._toast.mensajeInfo(element.descripcion, '');

          });
          callback();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error', '');
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  getEncuestasActivas(params: any, callback:any) {
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    let url = `encuestas/api/encuestas/${environment.processEnv}/v1/encuestas/encuesta-activa`;
    const request$ = this._dataApi.GetDataApiEncuestas(url,params).pipe(
      tap((result:any) => {
        this._toast.clearToasts();
        if (!result.hasError) {
          callback(result);
        } else {
          result.errors.forEach(element => {

            this._toast.mensajeInfo(element.descripcion, '');

          });
          callback();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error', '');
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  
  iniciarEncuesta(params: any, callback:any) {
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    let url = `encuestas/api/encuestas/${environment.processEnv}/v1/encuestas/encuesta/persona`;
    const request$ = this._dataApi.PostDataApiEncuestas(url,params).pipe(
      tap((result:any) => {
        this._toast.clearToasts();
        if (!result.hasError) {
          callback(result);
        } else {
          result.errors.forEach(element => {

            this._toast.mensajeInfo(element.descripcion, '');

          });
          callback();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error', '');
        return EMPTY;
      })
    );
    return request$.subscribe();
  }

  
  saveRespuesta(params: any, callback:any) {
    this._toast.mensajeLoading('Cargando', 'Procesando la información');
    let url = `encuestas/api/encuestas/${environment.processEnv}/v1/encuestas/encuesta-activa/persona-encuesta-respuesta`;
    const request$ = this._dataApi.PostDataApiEncuestas(url,params).pipe(
      tap((result:any) => {
        this._toast.clearToasts();
        if (!result.hasError) {
          callback(result);
        } else {
          result.errors.forEach(element => {

            this._toast.mensajeInfo(element.descripcion, '');

          });
          callback();
        }
      }),
      catchError((error: HttpErrorResponse) => {
        this._toast.clearToasts();
        this._mensajesHttp.mostrarErrorHttp(error, 'Ocurrio un error', '');
        return EMPTY;
      })
    );
    return request$.subscribe();
  }


}
